import { render, staticRenderFns } from "./CampaignReportOrdered.vue?vue&type=template&id=3ab65905&"
import script from "./CampaignReportOrdered.vue?vue&type=script&lang=js&"
export * from "./CampaignReportOrdered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports